/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';

import {
  // Text,
  View,
} from 'react-native';
import {
  Button,
  Text,
} from 'react-native-elements';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { translate } from '../locales/i18n';
import styles from '../styles';
import Header from '../components/misc/Header';

class Page404 extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.displayName = 'Page404';
  }

  render() {
    const { location, history } = this.props;

    return (
      <View
        style={[styles.view.form, {
          backgroundColor: 'white',
          width: '100%',
          padding: 0,
          margin: 0,
          alignItems: 'center',
          justifyContent: 'space-evenly',
        }]}
      >
        <Header
          hasBack
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            margin: 0,
          }}
          contentContainerStyle={styles.form.containerScrollable}
        >
          <Text
            style={{
              textAlign: 'center',
              fontSize: 20,
            }}
          >
            {translate('error_not_yet')}
          </Text>
          {/* <Button
            title={translate('menu_home')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
            buttonStyle={styles.buttonfsf.primary}
            titleStyle={styles.buttonfsf.primaryTitle}
            onPress={() => history.push('/ai-agents')}
            loadingProps={{ size: 'small', color: 'white' }}
          /> */}
        </KeyboardAwareScrollView>
      </View>
    );
  }
}

Page404.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
};

export default Page404;
